import { throttle, dispatchEvent, domReady, delay } from '../modules/utils.js';

class TopBar extends HTMLElement {
  static get observedAttributes() {
    return ['data-on-top'];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    this.refs = {
      menuButton: this.querySelector('.topbar-menu'),
    };
    this.#setListeners();
    this.#scrollHandle();

    await delay(100);
    this.toggleAttribute('data-active', true);
  }

  #setListeners() {
    this.refs.menuButton?.addEventListener('click', () => {
      dispatchEvent('mts:fullmenu-toggle');
    });

    document.addEventListener('mts:fullmenu-open', () => {
      this.toggleAttribute('data-menu-open', true);
    });

    document.addEventListener('mts:fullmenu-close', () => {
      this.toggleAttribute('data-menu-open', false);
    });
  }

  #scrollHandle() {
    let y = window.scrollY;

    const scrollTest = function () {
      const currentY = window.scrollY;

      if (!this.hasAttribute('data-disable-resize')) {
        this.toggleAttribute('data-on-top', currentY <= 0);
      }

      if (currentY > y) {
        this.setAttribute('data-scroll-direction', 'down');
      }
      else if (currentY < y) {
        this.setAttribute('data-scroll-direction', 'up');
      }

      y = currentY;
    }.bind(this);

    // immediate call
    scrollTest();
    setTimeout(scrollTest, 1000);

    window.addEventListener('scroll', throttle(scrollTest, 50));
  }
}

customElements.define('top-bar', TopBar);
